import React, { useState } from "react";
import { Select } from "antd";
import LowStock from "./low-stock";
import ProductSalesReportTotal from "./productsales-report-total";
import ProductwiseSaleReport from "./productwise-sale-report";

const { Option } = Select;

export default function ProductBased() {
  const [selectOption, setSelectOption] = useState("");
  return (
    <div>
      <div className="card custom-custom py-5 mb-10">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2>Product Based Reports</h2>
            </div>
            <div className="col-md-6">
              <div>
                <label htmlFor="">Select a Report</label>
              </div>
              <Select
                className="form-control"
                placeholder="Select a Report"
                onChange={(value) => setSelectOption(value)}
              >
                <Option value="1">Low Stock Product</Option>
                <Option value="2">Product Sales Total</Option>
                <Option value="3">Product Sales with Filter</Option>
              </Select>
            </div>
          </div>
        </div>
      </div>

      {selectOption === "1" && <LowStock />}
      {selectOption === "2" && <ProductSalesReportTotal />}
      {selectOption === "3" && <ProductwiseSaleReport />}
    </div>
  );
}
